var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { learningLounge } from "../../../../api";
import { utilities } from "../../../../utilities/utilities";
import { Dropdown } from "../../../../component/dropdown";
import { Element } from "../../../../element/element";
import { signIn } from "./signIn";
import { register } from "./register";
import { Tabs } from "../../../../component/tabs";
import { Spinner } from "../../../../component/spinner";
function stringToBoolean(str) {
    return str.toLowerCase() === "true";
}
var Authentication = /** @class */ (function () {
    function Authentication() {
        this.domainRegex = /^https?:\/\/(?:www\.)?(?:learninglounge\.com|localhost:44309)(\/.*)?$/;
        this.contentRegex = /^https?:\/\/(?:www\.)?(?:learninglounge\.com|localhost:44309)\/com\/([^/?]+)\/?(?:\?.*)?$/;
        this.isAuthenticated = false;
        this.account = null;
        this.isDefaultPage = false;
        this.isContentPage = false;
        this.isContentPageAndNotDefaultPage = false;
        this.isAnyPageAndNotDefaultPage = false;
        this.isWithinLL = false;
    }
    Object.defineProperty(Authentication.prototype, "url", {
        get: function () {
            return window.location.href;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authentication.prototype, "defaultPageUrl", {
        get: function () {
            var _a, _b;
            return ((_a = this.account) === null || _a === void 0 ? void 0 : _a.profile.defaultId)
                ? "".concat(learningLounge, "/en/select/").concat((_b = this.account) === null || _b === void 0 ? void 0 : _b.profile.defaultId)
                : "/";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authentication.prototype, "contentId", {
        //commodity id of the current page
        get: function () {
            var contentMatch = this.url.match(this.contentRegex);
            this.isContentPage = !!contentMatch;
            return contentMatch ? parseInt(contentMatch[1]) : null;
        },
        enumerable: false,
        configurable: true
    });
    Authentication.prototype.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            var path, response, result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        path = "".concat(learningLounge, "/cerberus/account/logout");
                        return [4 /*yield*/, fetch(path, {
                                method: 'POST',
                                credentials: 'include',
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        result = _a.sent();
                        if (result.success) {
                            authentication.renderSignedOut();
                            window.location.assign(window.location.href);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.error('Error logging out:', err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Authentication.prototype.openDefaultPage = function () {
        window.location.href = this.defaultPageUrl;
    };
    Authentication.prototype.updateDefaultPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var payload, response, toJson, responseMeta, isSuccessful, err_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        payload = this.isDefaultPage ? '' : this.contentId;
                        return [4 /*yield*/, fetch("".concat(learningLounge, "/account/page/default"), {
                                method: 'POST',
                                credentials: 'include',
                                headers: {
                                    "Content-Type": "application/x-www-form-urlencoded",
                                },
                                body: "DefaultEnrolmentCommodityId=".concat(payload)
                            })];
                    case 1:
                        response = _b.sent();
                        if (!response.ok) {
                            throw new Error("HTTP error! Status: ".concat(response.status));
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        toJson = _b.sent();
                        responseMeta = (_a = toJson === null || toJson === void 0 ? void 0 : toJson.responseMetaData) === null || _a === void 0 ? void 0 : _a[0];
                        if (!responseMeta)
                            throw new Error("No response metadata returned from server");
                        isSuccessful = responseMeta.responseRange === 1;
                        if (isSuccessful) {
                            if (payload) {
                                // Page successfully set as default
                                this.isDefaultPage = true;
                                this.isContentPageAndNotDefaultPage = true;
                                this.account.profile.defaultId = this.contentId;
                            }
                            else {
                                // Default page cleared
                                this.isDefaultPage = false;
                                this.isContentPageAndNotDefaultPage = false;
                                this.account.profile.defaultId = null;
                            }
                        }
                        else {
                            console.error('Failed to update default page:', responseMeta.responseDesc);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _b.sent();
                        console.error('Error updating default page:', err_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // async updateDefaultPage(){
    //     try {
    //         const response = await fetch(`${learningLounge}/account/page/default`, {
    //             method: 'POST',
    //             credentials: 'include',
    //             headers: {
    //                 "Content-Type": "application/x-www-form-urlencoded",
    //             },
    //             body: `DefaultEnrolmentCommodityId=${this.isContentPageAndNotDefaultPage ? '': this.contentId}`
    //         });
    //             if (!response.ok) {
    //             throw new Error(`HTTP error! Status: ${response.status}`);
    //         }
    //         const toJson = await response.json();
    //         const responseRange = toJson?.responseMetaData[0].responseRange;
    //         const isSuccessful = responseRange == 1;
    //         console.log(toJson, 'toJson')
    //         if(isSuccessful){
    //             if(!this.isDefaultPage){
    //                 this.isDefaultPage = true;
    //                 this.isContentPageAndNotDefaultPage = true;
    //                 (this.account as IAccount).profile.defaultId = this.contentId as number;
    //             }else{
    //                 this.isDefaultPage = false;
    //                 this.isContentPageAndNotDefaultPage = false;
    //                 (this.account as IAccount).profile.defaultId = null;
    //             }
    //         }
    //     } catch (err) {
    //         console.error('Error logging out:', err);
    //     }
    // }
    Authentication.prototype.setIsDefaultPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, e_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!((_a = authentication.instance) === null || _a === void 0 ? void 0 : _a.isContentPage))
                            return [2 /*return*/, false];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch("".concat(learningLounge, "/account/page/default/").concat((_b = authentication.instance) === null || _b === void 0 ? void 0 : _b.contentId), {
                                method: 'GET',
                                credentials: 'include',
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                }
                            })];
                    case 2:
                        response = _c.sent();
                        if (!response.ok) {
                            throw new Error("HTTP error! Status: ".concat(response.status));
                        }
                        return [4 /*yield*/, response.text()];
                    case 3:
                        data = _c.sent();
                        this.isDefaultPage = stringToBoolean(data);
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _c.sent();
                        this.isDefaultPage = false;
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Authentication.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var contentMatch, response, result, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        contentMatch = this.url.match(this.contentRegex);
                        this.isContentPage = !!contentMatch;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch("".concat(learningLounge, "/cerberus/account"), {
                                credentials: 'include',
                            })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        result = _a.sent();
                        if (result === null || result === void 0 ? void 0 : result.authenticated) {
                            this.isAuthenticated = true;
                            this.account = result.account;
                            this.isWithinLL = this.domainRegex.test(this.url);
                            // if(result?.account?.profile?.defaultId){
                            //     this.openDefaultPage();
                            // }
                            // if (result) {
                            //     window.location.href = this.returnUrl;
                            //     return;
                            // }
                            // await this.setIsDefaultPage();
                            this.isContentPageAndNotDefaultPage = this.isContentPage && !this.isDefaultPage;
                            this.isAnyPageAndNotDefaultPage = this.isWithinLL && !this.isDefaultPage;
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        err_3 = _a.sent();
                        console.error('Error fetching account info:', err_3);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return Authentication;
}());
export var authentication = {
    element: null,
    toggle: null,
    toggleText: null,
    dropdownInstance: null,
    instance: null,
    get contentContainer() {
        var _a;
        return (_a = authentication.element) === null || _a === void 0 ? void 0 : _a.querySelector('.content-container');
    },
    init: function () {
        if (!authentication.element)
            return;
        authentication.dropdownInstance = new Dropdown({
            element: authentication.element,
            options: {
                offset: [-284, 0],
                autoClose: 'outside',
            },
        });
        authentication.dropdownInstance.init();
    },
    renderSignedOut: function () {
        var _a, _b;
        var toggleText = utilities.html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Sign in"], ["Sign in"])));
        var tabs = new Tabs({
            tabs: [
                {
                    condition: true,
                    link: {
                        title: 'Sign in'
                    },
                    content: signIn().render()
                },
                {
                    condition: true,
                    link: {
                        title: 'Register'
                    },
                    content: register().render()
                },
                {
                    condition: true,
                    link: {
                        title: 'Help'
                    },
                    content: utilities.html(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                        <div>\n                            <h4 class=\"create-account my-3\">Account help</h4>\n                            <ul class=\"account-help\" style=\"list-style:none\">\n                                <li>\n                                    <icon class=\"fa-solid fa-lock\" style=\"color: #808080;margin-right:1.2em;\"></icon>\n                                    Password minimum requirements: \n                                    <ul>\n                                        <li>Up to 12 characters</li>\n                                        <li>Upper and lower case letters</li>\n                                        <li>1 or more digits</li>\n                                        <li>1 or more special characters such as !?@</li>\n                                    </ul>\n                                </li>\n                                <li>\n                                    <icon class=\"fa-solid fa-user-lock\" style=\"color: #808080;margin-right:1.2em;\"></icon>\n                                    <a href=\"/Account/ForgotPassword?Length=7\" style=\"color:#fff;\">\n                                        Forgotten your password? Click Here\n                                    </a>\n                                </li>\n                            </ul>\n                        </div>\n                    "], ["\n                        <div>\n                            <h4 class=\"create-account my-3\">Account help</h4>\n                            <ul class=\"account-help\" style=\"list-style:none\">\n                                <li>\n                                    <icon class=\"fa-solid fa-lock\" style=\"color: #808080;margin-right:1.2em;\"></icon>\n                                    Password minimum requirements: \n                                    <ul>\n                                        <li>Up to 12 characters</li>\n                                        <li>Upper and lower case letters</li>\n                                        <li>1 or more digits</li>\n                                        <li>1 or more special characters such as !?@</li>\n                                    </ul>\n                                </li>\n                                <li>\n                                    <icon class=\"fa-solid fa-user-lock\" style=\"color: #808080;margin-right:1.2em;\"></icon>\n                                    <a href=\"/Account/ForgotPassword?Length=7\" style=\"color:#fff;\">\n                                        Forgotten your password? Click Here\n                                    </a>\n                                </li>\n                            </ul>\n                        </div>\n                    "])))
                }
            ]
        });
        var tabsElement = tabs.generate();
        tabsElement === null || tabsElement === void 0 ? void 0 : tabsElement.classList.add('authentication-dropdown-tabs');
        var content = utilities.html(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            <div class=\"d-flex flex-column gap-3\">\n                ", "\n            </div>\n        "], ["\n            <div class=\"d-flex flex-column gap-3\">\n                ", "\n            </div>\n        "])), tabsElement);
        (_a = authentication.toggleText) === null || _a === void 0 ? void 0 : _a.replaceWith(toggleText);
        authentication.toggleText = toggleText;
        authentication.contentContainer.innerHTML = '';
        (_b = authentication.contentContainer) === null || _b === void 0 ? void 0 : _b.appendChild(content);
        tabs.init();
    },
    renderSignedIn: function (account) {
        var result = {
            dashboard: null,
            renderDefaultToggle: function () {
                var _this = this;
                var _a, _b;
                return new Element({
                    composer: {
                        content: utilities.html(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                            <a role=\"button\" class=\"d-flex align-items-center gap-2 text-white p-2\">\n                                <i class=\"fa-", " fa-fw fa-heart\"></i>\n                                ", " as default page\n                            </a>\n                        "], ["\n                            <a role=\"button\" class=\"d-flex align-items-center gap-2 text-white p-2\">\n                                <i class=\"fa-", " fa-fw fa-heart\"></i>\n                                ", " as default page\n                            </a>\n                        "])), ((_a = authentication.instance) === null || _a === void 0 ? void 0 : _a.isDefaultPage) ? 'solid' : 'regular', ((_b = authentication.instance) === null || _b === void 0 ? void 0 : _b.isDefaultPage) ? 'Remove' : 'Set')
                    },
                    events: {
                        click: function (e) { return __awaiter(_this, void 0, void 0, function () {
                            var spinner, newToggle;
                            var _a, _b, _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        spinner = new Spinner({}).render();
                                        e.preventDefault();
                                        (_a = e.target) === null || _a === void 0 ? void 0 : _a.replaceWith(spinner);
                                        return [4 /*yield*/, ((_b = authentication.instance) === null || _b === void 0 ? void 0 : _b.updateDefaultPage())];
                                    case 1:
                                        _d.sent();
                                        newToggle = result.renderDefaultToggle();
                                        spinner.replaceWith(newToggle);
                                        (_c = result.dashboard) === null || _c === void 0 ? void 0 : _c.classList.toggle('d-none');
                                        return [2 /*return*/];
                                }
                            });
                        }); }
                    }
                }).render();
            },
            render: function () {
                var _this = this;
                var _a, _b, _c;
                var toggleText = utilities.html(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                    <div style=\"height:40px; width:40px; background-color:#df910c;\" class=\"rounded-circle bg-gradient h5 mb-0 flex-shrink d-flex justify-content-center align-items-center\">\n                        ", "\n                    </div>\n                "], ["\n                    <div style=\"height:40px; width:40px; background-color:#df910c;\" class=\"rounded-circle bg-gradient h5 mb-0 flex-shrink d-flex justify-content-center align-items-center\">\n                        ", "\n                    </div>\n                "])), account.profile.initials.split("").join(" "));
                //${!authentication.instance?.isDefaultPage ? 'd-flex' : 'd-none'}
                result.dashboard = new Element({
                    composer: {
                        content: utilities.html(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n                            <a role=\"button\" class=\" align-items-center gap-2 text-white p-2\">\n                                <i class=\"fa-solid fa-gauge fa-fw\"></i>\n                                My dashboard\n                            </a>\n                        "], ["\n                            <a role=\"button\" class=\" align-items-center gap-2 text-white p-2\">\n                                <i class=\"fa-solid fa-gauge fa-fw\"></i>\n                                My dashboard\n                            </a>\n                        "])))
                    },
                    events: {
                        // click: async () => authentication.instance?.openDefaultPage()
                        click: function () { return window.location.href = '/'; }
                    }
                }).render();
                var content = utilities.html(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n                    <div class=\"d-flex flex-column gap-2\">\n                        <div class=\"d-flex flex-wrap text-wrap h5 text-center fw-bold\">\n                            ", " ", "\n                        </div>\n                        <div class=\"d-flex flex-column gap-2 ms-4\">\n                            <a class=\"d-flex align-items-center gap-2 text-white p-2\" href=\"", "/account/manage\">\n                                <i class=\"fa-solid fa-fw fa-user-gear\"></i>\n                                Manage account\n                            </a>\n                            ", "\n                            ", "\n                            ", "\n                        </div>\n                    </div>\n                "], ["\n                    <div class=\"d-flex flex-column gap-2\">\n                        <div class=\"d-flex flex-wrap text-wrap h5 text-center fw-bold\">\n                            ", " ", "\n                        </div>\n                        <div class=\"d-flex flex-column gap-2 ms-4\">\n                            <a class=\"d-flex align-items-center gap-2 text-white p-2\" href=\"", "/account/manage\">\n                                <i class=\"fa-solid fa-fw fa-user-gear\"></i>\n                                Manage account\n                            </a>\n                            ", "\n                            ", "\n                            ", "\n                        </div>\n                    </div>\n                "])), account.profile.firstName, account.profile.lastName, learningLounge, result.dashboard, ((_a = authentication.instance) === null || _a === void 0 ? void 0 : _a.isContentPage) && result.renderDefaultToggle(), new Element({
                    composer: {
                        content: utilities.html(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n                                        <a role=\"button\" class=\"d-flex align-items-center gap-2 text-white p-2\">\n                                            <i class=\"fa-solid fa-right-from-bracket fa-fw\"></i>\n                                            Sign out\n                                        </a>\n                                    "], ["\n                                        <a role=\"button\" class=\"d-flex align-items-center gap-2 text-white p-2\">\n                                            <i class=\"fa-solid fa-right-from-bracket fa-fw\"></i>\n                                            Sign out\n                                        </a>\n                                    "])))
                    },
                    events: {
                        click: function (e) { return __awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        e.preventDefault();
                                        return [4 /*yield*/, ((_a = authentication.instance) === null || _a === void 0 ? void 0 : _a.signOut())];
                                    case 1:
                                        _b.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }
                    }
                }).render());
                (_b = authentication.toggleText) === null || _b === void 0 ? void 0 : _b.replaceWith(toggleText);
                authentication.toggleText = toggleText;
                authentication.contentContainer.innerHTML = '';
                (_c = authentication.contentContainer) === null || _c === void 0 ? void 0 : _c.appendChild(content);
            }
        };
        return result;
    },
    render: function () {
        var _this = this;
        authentication.toggleText = utilities.html(templateObject_9 || (templateObject_9 = __makeTemplateObject(["<div></div>"], ["<div></div>"])));
        authentication.toggle = utilities.html(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n            <button type=\"button\" class=\"btn btn-lg h-100 shadow-0 toggle text-white fw-light d-flex align-items-center gap-2\" style=\"font-weight:normal !important;\">\n                ", "\n                <i class=\"fa-solid fa-caret-down\"></i>\n            </button>\n        "], ["\n            <button type=\"button\" class=\"btn btn-lg h-100 shadow-0 toggle text-white fw-light d-flex align-items-center gap-2\" style=\"font-weight:normal !important;\">\n                ", "\n                <i class=\"fa-solid fa-caret-down\"></i>\n            </button>\n        "])), authentication.toggleText);
        authentication.element = utilities.html(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n            <div class=\"dropdown d-flex align-items-center text-white\" style=\"height:56px\">\n                ", "\n                <ul id=\"site-account-dropdown\" class=\"dropdown-menu rounded-0 text-white py-0 shadow\" style=\"min-width:255px; width:400px; max-width:100vw; background:#212529; font-size:14px !important\">\n                    <div class=\"position-relative h-100 w-100 overflow-auto content-container p-4 d-flex flex-column\">\n                    </div>\n                </ul>\n            </div>\n        "], ["\n            <div class=\"dropdown d-flex align-items-center text-white\" style=\"height:56px\">\n                ", "\n                <ul id=\"site-account-dropdown\" class=\"dropdown-menu rounded-0 text-white py-0 shadow\" style=\"min-width:255px; width:400px; max-width:100vw; background:#212529; font-size:14px !important\">\n                    <div class=\"position-relative h-100 w-100 overflow-auto content-container p-4 d-flex flex-column\">\n                    </div>\n                </ul>\n            </div>\n        "])), authentication.toggle);
        authentication.init();
        this.instance = new Authentication();
        var spinner = new Spinner({}).render();
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, ((_a = this.instance) === null || _a === void 0 ? void 0 : _a.init())];
                    case 1:
                        _d.sent();
                        return [4 /*yield*/, ((_b = authentication.instance) === null || _b === void 0 ? void 0 : _b.setIsDefaultPage())];
                    case 2:
                        _d.sent();
                        if ((_c = this.instance) === null || _c === void 0 ? void 0 : _c.isAuthenticated) {
                            authentication.renderSignedIn(this.instance.account).render();
                        }
                        else {
                            authentication.renderSignedOut();
                        }
                        spinner === null || spinner === void 0 ? void 0 : spinner.replaceWith(authentication.element);
                        return [2 /*return*/];
                }
            });
        }); })();
        return spinner;
    }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
